import {
    styled,
    ToggleButton,
    ToggleButtonProps,
    ToggleButtonTypeMap,
} from "@mui/material";

export const InlineReactionToggleButton = styled(ToggleButton, {
    shouldForwardProp: (prop) => prop !== "activeColor",
})<{ activeColor?: string }>(({ activeColor }) => ({
    fontSize: "14px",
    marginRight: "8px",
    padding: "0px",
    backgroundColor: "transparent",
    color: "var(--community-color-primary-text)",
    fontWeight: 400,
    border: "unset",
    lineHeight: "1.75",
    height: 32,
    borderRadius: 90,
    textTransform: "none",
    "&:hover": {
        backgroundColor: "transparent",
    },
    "&.Mui-selected": {
        backgroundColor: "transparent",
        color: activeColor ?? "var(--community-color-light-steal-blue)",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    svg: {
        marginRight: 4,
        width: "20px",
        height: "20px",
    },
    "&.MuiToggleButtonGroup-grouped": {
        borderRadius: "90px",
    },
}));

export const ReactionToggleButton = styled(ToggleButton)({
    width: "40px",
    height: "40px",
    marginRight: "8px",
    border: "none !important",
    svg: {
        transition: "all 0.3s",
        width: "32px",
        height: "32px",
    },
    "&.MuiToggleButtonGroup-grouped": {
        margin: "0 !important",
        borderRadius: "90px !important",
    },
    "&.MuiToggleButtonGroup-grouped:hover": {
        backgroundColor: "var(--community-color-snow-white)",
        svg: {
            width: "40px",
            height: "40px",
        },
    },
    "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor:
            "var(--community-active-action-buttons-background-color)",
    },
});

export const ModalReactionToggleButton = styled(ToggleButton)({
    width: "40px",
    height: "40px",
    marginRight: "8px",
    border: "none !important",
    svg: {
        transition: "all 0.3s",
        width: "32px",
        height: "32px",
    },
    "&.MuiToggleButtonGroup-grouped": {
        margin: "0 !important",
        borderRadius: "90px !important",
    },
    "&.MuiToggleButtonGroup-grouped:hover": {
        backgroundColor: "var(--community-color-snow-white)",
        svg: {
            width: "40px",
            height: "40px",
        },
    },
    "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor:
            "var(--community-active-action-buttons-background-color)",
    },
});

export type StyledToggleButtonProps = ToggleButtonProps<
    ToggleButtonTypeMap["defaultComponent"],
    { unsetHeight?: boolean }
>;

export const StyledToggleButton = styled(ToggleButton, {
    shouldForwardProp: (prop) => prop !== "unsetHeight",
})<StyledToggleButtonProps>((props) => ({
    "&.MuiToggleButton-root.MuiToggleButtonGroup-grouped": {
        padding: "4px",
        color: "var(--community-color-primary-text)",
        border: "unset",
        lineHeight: "1.75",
        height: props.unsetHeight ? "unset" : "28px",
        borderRadius: "90px !important",
        minWidth: "unset",
        margin: "2px",
    },
}));
